import type { FeatureFlagDecision } from 'ab-test/types'

export function shouldRequestSDK(
	abRequested: boolean,
	preventRequestSDK: boolean
) {
	return !abRequested && !preventRequestSDK
}

export function getAbDecision(
	abTest: FeatureFlagDecision | undefined,
	defaultDecision: Partial<FeatureFlagDecision> | undefined
) {
	return abTest
		? {
				enabled: abTest?.enabled,
				variables: abTest?.variables,
			}
		: defaultDecision
}
